/*
 * @Author: luting
 * @Date: 2022-04-19 18:54:08
 * @lastEditors: luting
 * @LastEditTime: 2022-10-24 17:46:44
 */
import React from 'react';
import { useIntl } from 'react-intl';

import empty from 'root/assets/images/illustrator_empty.svg';
import messages from '../messages';

import styles from '../index.less';

const InitPage = () => {
  const intl = useIntl();

  return (
    <div className={styles.init_page}>
      <img src={empty} />
      <div className={styles.tip}>{intl.formatMessage(messages.initPage)}</div>
    </div>
  );
};

export default InitPage;
